import "./RibbonHeaderTabs.css";

import RibbonTab from "./RibbonTab.jsx";
import { GetRibbonTabsSettings } from "./RibbonTabsSettings.jsx";

const RibbonHeaderTabs = () => {
	const ribbonTabsSettings = GetRibbonTabsSettings();

	return (
		<div className="ribbon-header-tabs">
			{ribbonTabsSettings.map((tab, index) => (
				<RibbonTab key={index} {...tab} />
			))}
		</div>
	);
};

export default RibbonHeaderTabs;
